import React from 'react'
import Box from '@mui/material/Box'
import PathToAI from 'components/landing/Path'
import GlobalDelivery from 'components/landing/GlobalDelivery'
import LogoShowcase from 'components/landing/LogoShowcase'
import Team from 'components/Team'
import Page from 'components/Page'

const Home: React.FC = () => {
  return (
    <Page title="EquiStamp" fullWidth>
      <Box
        sx={{
          position: 'relative',
          height: '500px', // Adjust height as needed
          width: '100%',
          backgroundImage: 'url(/imgs/gradientswirl.png)', // Replace with your background image path
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          component="img"
          src="/imgs/tagline.png" // Replace with your text image path
          alt="Hero Text"
          sx={{
            maxWidth: '80%',
            maxHeight: '80%',
            zIndex: 2,
          }}
        />
      </Box>
      <PathToAI />
      <GlobalDelivery />
      <LogoShowcase />
      <Team />
    </Page>
  )
}

export default Home
